import client from './client';

export interface Payslip {
  id: number;
  company_id: number;
  user_id: number;
  employee_id?: number | null;
  title: string;
  period_label?: string | null;
  period_start?: string | null;
  period_end?: string | null;
  period_display?: string | null;
  original_filename?: string | null;
  uploaded_by: number;
  created_at: string;
  user_name?: string | null;
  user_email?: string | null;
  employee_name?: string | null;
}

interface PayslipsListResponse {
  success: boolean;
  data: {
    payslips: Payslip[];
    total?: number;
    page?: number;
    pages?: number;
  };
}

interface PayslipResponse {
  success: boolean;
  data: Payslip;
  message?: string;
}

export const payslipsApi = {
  list: (params?: { user_id?: number; employee_id?: number; page?: number; per_page?: number }) =>
    client.get<PayslipsListResponse>('/payslips', { params }),

  listMine: () => client.get<PayslipsListResponse>('/payslips/me'),

  upload: (formData: FormData) =>
    client.post<PayslipResponse>('/payslips', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  download: (id: number) =>
    client.get(`/payslips/${id}/download`, { responseType: 'blob' }),

  delete: (id: number) => client.delete(`/payslips/${id}`),
};
